import {
  CALENDAR_LAST_YEAR_PAGINATION_ALLOWED,
  DECEMBER_INDEX,
  EVENTS,
  MODALS,
  MODES,
  NOVEMBER_INDEX,
  STATUS_CODE_OK
} from 'common/domain/constants';
import {
  Request
} from 'common/domain/models/request';
import {
  STATES
} from 'common/domain/states';
import moment from 'moment';
import {
  RESOLUTION,
  VA_MY_VACATIONS_MODAL_COACHMARK_CONFIG
} from 'vacations-absences.module/common/domain/constants';
import MyVacationsCsv from './myVacations.csv';
import VacationScheduleEndDateHelper from './vacationScheduleEndDate.helper';

class MyVacationsController {
  constructor(vacationUserDataService,
    $scope,
    $timeout,
    $rootScope,
    $filter,
    $window,
    $q,
    $log,
    vacationDelegationService,
    VacationScheduleEndDateService,
    vacationEmployeeRepositoryService,
    ManagerForEmployeeService,
    vacationsAbsencesService,
    modalsBehaviourService,
    HelperDelegationsService) {
    'ngInject';
    this.filter = $filter;
    this.rootScope = $rootScope;
    this.timeout = $timeout;
    this.scope = $scope;
    this.window = $window;
    this.q = $q;
    this.log = $log;

    this.vacationDelegationService = vacationDelegationService;
    this.VacationScheduleEndDateService = VacationScheduleEndDateService;
    this.employeeRepositoryService = vacationEmployeeRepositoryService;
    this.UserDataService = vacationUserDataService;
    this.vacationsAbsencesService = vacationsAbsencesService;
    this.ManagerForEmployeeService = ManagerForEmployeeService;
    this.modalsBehaviourService = modalsBehaviourService;
    this.helperDelegations = HelperDelegationsService;

    this.loaded = false;
    this.myVacationsCsv = new MyVacationsCsv();
    this.filters = [];
    this.hasNoManager = false;
    this.startDate = '';
    this.dateToday = new Date();
    this.dateTodayMonth = this.dateToday.getMonth();
    this.year = this.dateToday.getFullYear();
    this.currentEmployee = {};
    this.delegation = {};
    this.coachmarkData = VA_MY_VACATIONS_MODAL_COACHMARK_CONFIG;
    this.isMobileApp = $window.innerWidth < 1024;
  }

  $onInit() {
    this.userId = this.UserDataService.getEmployee().userId;
    this.urlDestination = STATES.VACATIONS_ABSENCES.DELEGATE;
    this.modalIsInitialized = true;

    let promises = {
      employee: this.employeeRepositoryService.getEmployee(this.userId, this.year, this.userInceptionId),
      schedule: this.VacationScheduleEndDateService.get(),
      delegations: this.vacationDelegationService.getDelegations(this.userId),
      manager: this.ManagerForEmployeeService.getManagerForEmployee(this.userId)
    };

    this.q.allSettled(promises).then(responses => {
      if (responses.employee.isFulfilled) {
        this._loadData(responses.employee.value);
      } else {
        this.log.error('MyVacationsController endpoint getEmployee', responses.employee.reason);
      }

      if (responses.schedule.isFulfilled) {
        this._initVacationSchedule(responses.schedule.value);
      } else {
        this.log.error('MyVacationsController endpoint get scheduleEndDate', responses.schedule.reason);
      }

      if (responses.delegations.isFulfilled) {
        this._initDelegations(responses.delegations.value);
      } else {
        this.log.error('MyVacationsController endpoint getDelegations', responses.delegations.reason);
      }
      if (responses.manager.isRejected || responses.manager.value.managerId === null) {
        let errorMsg = responses.manager.reason && responses.manager.reason.data && responses.manager.reason.data.message ? responses.manager.reason.data.message : 'No manager data';
        this._initManagerForEmployee(errorMsg);
      } else if (responses.manager.isRejected) {
        this.log.error('MyVacationsController endpoint getManagerForEmployee', responses.delegations.reason);
      }
    });

    this.resolution = this.getResolution();

    this.modalsBehaviourService.reset();
    this.visitedDelegation = this.helperDelegations.getVisitDelegation(this.userId);
  }

  $postLink() {
    angular.element(this.window).bind('resize', () => {
      this.resolution = this.getResolution();
      this.scope.$apply();
    });
  }

  get requestModal() {
    const $modal = $(MODALS.REQUEST);

    if ($modal.length > 0) {
      this.configRequestHolidayModal($modal);
    }

    return $modal;
  }

  get modalSchedule() {
    return $(MODALS.CALENDAR_GRID);
  }

  get modalWarningDelegation() {
    const $modal = $(MODALS.WARNING_DELEGATION_MODAL);
    $modal.on('hidden.bs.modal', () => {
      this.helperDelegations.setVisitedDelegation(this.userId);
    });
    return $modal;
  }

  _loadData(employee) {
    this.currentEmployee = employee;
    this.rootScope.$broadcast(EVENTS.REFRESH_EMPLOYEE, this.currentEmployee);
    this.rawPeriodDays = employee.periodInDays;
    this.user = employee.getProfile();
    this.availableVacations = employee.availableVacations;
    this.vacationCount = employee.getAgreementVacationCount();
    this.allPeriods = employee.allPeriods;
    this.loaded = true;
  }

  _initVacationSchedule(schedule) {
    this.vacationScheduleEndDateHelper = new VacationScheduleEndDateHelper(schedule.startDate, schedule.endDate, this.availableVacations);
    this.modalsBehaviourService.warnLastDayShouldBeVisible = this.vacationScheduleEndDateHelper.start();
    this.vacationScheduleEndDate = this.vacationScheduleEndDateHelper.getViewDate();
  }

  _initDelegations(delegations) {
    this._findDelegationActive(delegations);
    this._showModalWarningDelegation();
  }

  _initManagerForEmployee(message) {
    this.noManagerMessage = message;
    this.hasNoManager = true;
  }

  _requestData(userId, userInceptionId) {
    return this.employeeRepositoryService.getEmployee(userId, this.year, userInceptionId).then((employee) => {
      this._loadData(employee);
    });
  }

  _reloadData(startDate, endDate) {
    this._requestData(this.userId, this.userInceptionId).then(() => {
      this.rootScope.$broadcast(EVENTS.ADD_PERIOD, {
        startDate: startDate.getMonth(),
        endDate: endDate,
      });
    });
  }

  _findDelegationActive(delegations) {
    const today = moment().format('YYYY-MM-DD');
    this.delegation = this.vacationDelegationService
      .findDelegationActive(today, delegations);
    this.isDelegationDateRight = Object.keys(this.delegation).length;
  }

  _showModalWarningDelegation() {
    let delegationEmpty = this.helperDelegations.isDelegationEmpty(this.delegation);
    if (delegationEmpty || this.visitedDelegation) {
      return;
    }

    this.modalWarningDelegation.modal('show');
  }

  addEvent({
    startDate,
    endDate
  }) {
    this._reloadData(startDate, endDate);
  }

  removePeriod({
    status,
    startDate,
    endDate
  }) {
    if (status === STATUS_CODE_OK) {
      this._reloadData(startDate, endDate);
    }
  }

  selectDay({
    date
  }) {
    if (this.isWageInProcess) {
      return;
    }

    this.startDate = date;
    this.openRequestHolidayModal();
  }

  onChangeFilters({
    filters
  }) {
    this.filters = filters;
    this.filterPeriods();
  }

  filterPeriods() {
    this.currentEmployee.periodInDays = this.filter('filterPeriods')(this.rawPeriodDays, this.filters);
    this.rootScope.$broadcast(EVENTS.FILTER_PERIOD);
  }

  onEditPeriod($event) {
    this.startDate = $event.dateDayClicked;
    this.requestHolidayMode = MODES.EDIT;
    this.periodToEdit = $event.period;
    this.originalPeriod = angular.copy($event.period);
    this.periodToEdit.startDate = new Date(this.periodToEdit.startDate);

    if (this.periodToEdit.endDate) {
      this.periodToEdit.endDate = new Date(this.periodToEdit.endDate);
    }

    this.openRequestHolidayModal();
  }

  openAbsences($event) {
    this.startDate = $event.dateDayClicked;
    this.requestModalOpenOn = 'absence';
    this.openRequestHolidayModal();
  }

  openRequestHolidayModal() {
    if (!this.requestHolidayMode) {
      this.requestHolidayMode = MODES.CREATE;
    }

    this.timeout(() => {
      this.modalIsInitialized = true;
      this.scope.$apply();
      this.requestModal.modal('show');
    });
  }

  configRequestHolidayModal(modal) {
    modal.on('hidden.bs.modal', () => {
      this.modalIsInitialized = false;
      this.timeout(() => {
        this.startDate = '';
        this.requestHolidayMode = MODES.CREATE;
        this.unSelectActiveDay();
        delete this.requestModalOpenOn;
        delete this.periodToEdit;
      });
    });
  }

  unSelectActiveDay() {
    const activeDay = angular.element('.datepicker table tr td.active');
    const activeClass = 'active';
    activeDay.removeClass(activeClass);
  }

  findPeriod(startDate, endDate) {
    return this.currentEmployee.periodInDays.find((event) => {
      let day = event.day;
      if (!day) return;
      const compareDate = new Date(day);
      return compareDate.getTime() === startDate.getTime() || compareDate.getTime() === endDate.getTime();
    });
  }

  getManagerClass() {
    if (Object.keys(this.currentEmployee).length === 0) {
      return;
    }

    return {
      manager: this.currentEmployee.isManager(),
    };
  }

  closeInception() {
    this.window.history.back();
    this.timeout(() => this.scope.$apply());
  }

  isInception() {
    return !!this.userInceptionId;
  }

  getResolution() {
    return this.isTabletResolution() ? 'tablet' : 'desktop';
  }

  isTabletResolution() {
    return this.window.innerWidth <= RESOLUTION.DESKTOP;
  }

  setWarnModalDisplayed() {
    process.isWarnModalBeenDisplayed = true;
  }

  isWarnModalBeenDisplayed() {
    return process.isWarnModalBeenDisplayed;
  }

  coachmarkIsDismissed({
    modalDismissed
  }) {
    this.modalsBehaviourService.coachmarkModalDismissed = modalDismissed;
  }

  openModalSchedule() {
    this.modalScheduleIsVisible = true;
    this.timeout(() => this.modalSchedule.modal('show'));
  }

  closeModalSchedule() {
    this.timeout(() => this.modalScheduleIsVisible = false);
  }

  isModalOpen() {
    return {
      'modal-open': this.modalScheduleIsVisible
    };
  }

  getMyVacationsCsv() {
    const periodsWithoutHolidays = this.allPeriods.filter(period => period.type !== Request.TYPES.HOLIDAY);
    return this.myVacationsCsv.getMyVacationsCsv(periodsWithoutHolidays);
  }

  getMyVacationsCsvHeader() {
    return this.myVacationsCsv.getMyVacationsCsvHeader();
  }

  paginationPrevious() {
    this.loaded = false;
    this.year = this.year - 1;
    this.dateToday.setFullYear(this.year);
    this.$onInit();
  }

  paginationNext() {
    this.loaded = false;
    this.year = this.year + 1;
    this.dateToday.setFullYear(this.year);
    this.$onInit();
  }

  showNextArrow() {
    let today = new Date();
    let currentYear = today.getFullYear();
    let currentDay = today.getDate();

    let isPrevYear = this.isPreviousYear(currentYear);
    let isEndPeriod = this.endPeriodOfCurrentYear(currentDay, this.dateTodayMonth, currentYear);

    return isPrevYear || isEndPeriod;
  }

  isPreviousYear(currentYear) {
    return this.year < currentYear;
  }

  endPeriodOfCurrentYear(currentDay, currentMonth, currentYear) {
    return this.year !== currentYear ? false : this.isEndOfYearPeriod(currentDay, currentMonth);
  }

  isEndOfYearPeriod(currentDay, currentMonth) {
    return (currentMonth === NOVEMBER_INDEX && currentDay >= 20) || currentMonth === DECEMBER_INDEX;
  }

  showPreviousArrow() {
    let lastAlowedYear = CALENDAR_LAST_YEAR_PAGINATION_ALLOWED;
    return this.year !== lastAlowedYear;
  }
}

export default MyVacationsController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/myVacations/myVacations.controller.js